import React, { createRef } from "react";
import Box from "@material-ui/core/Box";
import Switch from "@material-ui/core/Switch";
import Chip from "@material-ui/core/Chip";
import { Typography, withStyles } from "@material-ui/core";
import {
  CustomMaintenanceIcon,
  CustomAnalyticsIcon,
  CustomFuelIcon,
  CustomTollIcon,
} from "../../../common/icons";
import { Select } from "antd";
import { injectIntl, defineMessages } from "react-intl";
import { solutionsEnum } from "../enums/solutions";
import { InfoAlertCardSolutions } from "../alerts/InfoAlertCardSolutions";

const messages = defineMessages({
  alwaysSelected: {
    id: "solution.card.alwaysSelected",
    defaultMessage: "Always selected",
  },
  discover: {
    id: "solution.card.discover",
    defaultMessage: "Discover",
  },
  customerCode: {
    id: "solution.card.customerCode",
    defaultMessage: "My customer code",
  },
});

const RedSwitch = withStyles({
  switchBase: {
    color: "#ccc",
    "&$checked": {
      color: "#F72717",
    },
    "&$checked + $track": {
      backgroundColor: "#F72717",
    },
  },
  checked: {},
  track: {},
})(Switch);

export class SolutionCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isEnabled: props.activeSolutions?.has(props.id) || false,
      solutionCodes: [],
    };
  }

  get icon() {
    switch (this.props.icon?.toString().toLowerCase()) {
      case "carrinhofuel":
        return <CustomFuelIcon />;
      case "carrinhomaintenance":
        return <CustomMaintenanceIcon />;
      case "toolbardividericon":
        return <CustomTollIcon />;
      default:
        return <CustomAnalyticsIcon />;
    }
  }

  get isTtoll() {
    return this.props.code === solutionsEnum.TTOLL;
  }

  handlerSwitchChange() {
    const status = !this.state.isEnabled;

    this.setState({
      isEnabled: status,
    });

    if (this.props.onSolutionToggle) {
      this.props.onSolutionToggle(this.props.id, status);
    }

    if (status && this.props?.id && !this.isTtoll) {
      this.props
        .getSolutionsCodes(this.props?.id)
        .then((data) => {
          this.setState({
            solutionCodes: Array.isArray(data) ? data : [],
          });
        })
        .catch(console.error);
    } else {
      if (
        Array.isArray(this.selectClientCodeRef?.current?.rcSelect?.state?.value)
      ) {
        this.selectClientCodeRef.current.rcSelect.state.value = [];
      }
    }
  }

  render() {
    const { intl, code, isMain, companyHasSolution } = this.props;
    const showCustomerCodeSelect = !isMain && !this.isTtoll;

    return (
      <Box
        sx={{
          width: "100%",
          boxShadow: this.state.isEnabled
            ? "0px 0px 1px green"
            : "0px 0px 1px #000",
          borderRadius: "10px",
          padding: "1rem",
          borderColor: "#1E293B",
          border: "1px solid",
          "& .card-content": {
            display: "flex",
            flexDirection: "column",
          },
          "& .card-header": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          },
          "& .card-content .card-title": {
            textAlign: "left",
            margin: "1rem 0",
          },
          "& .card-content .card-description": {
            textAlign: "left",
            overflow: "hidden",
            textOverflow: "ellipsis",
            padding: "1rem 0",
            flex: 1,
            minHeight: "100px",
          },
        }}
      >
        <div className="card-header">
          {this.icon}
          {this.props.isMain ? (
            <Chip
              style={{
                backgroundColor: "#E7F3FF",
                color: "#0A76DC",
                borderRadius: "40px",
                fontWeight: 700,
                fontSize: "10px",
              }}
              label={intl.formatMessage(messages.alwaysSelected)}
            />
          ) : (
            <RedSwitch
              onChange={() => this.handlerSwitchChange()}
              checked={this.state.isEnabled}
              disabled={
                this.props.status === 0 || !this.props.companyHasSolution
              }
            />
          )}
        </div>
        <div className="card-content">
          <Typography
            style={{
              fontWeight: 500,
              color: "#1E293B",
              fontFamily: "'Ubuntu', Arial, sans-serif",
              fontSize: "20px",
            }}
            className="card-title"
          >
            {this.props.name}
          </Typography>
          <Typography
            style={{
              fontWeight: 400,
              color: "#525866",
              fontFamily: "'Ubuntu', Arial, sans-serif",
              fontSize: "14px",
            }}
            className="card-description"
          >
            {this.props.description}
          </Typography>
          {showCustomerCodeSelect && (
            <Typography
              style={{
                fontFamily: "'Ubuntu', Arial, sans-serif",
                fontWeight: 700,
                fontSize: "12px",
                marginLeft: "10px",
              }}
            >
              {intl.formatMessage(messages.customerCode)}
              {this.state.isEnabled ? (
                <span style={{ color: "#F72717", marginLeft: 2 }}>*</span>
              ) : null}
            </Typography>
          )}

          {!isMain && this.isTtoll && companyHasSolution && (
            <InfoAlertCardSolutions />
          )}

          {showCustomerCodeSelect && companyHasSolution && (
            <Box
              sx={{
                "& .ant-select-selection__rendered": {
                  lineHeight: "0",
                },
              }}
              disabled={!this.state.isEnabled}
              placeholder=""
              component={Select}
              value={
                this.props.solutionsCodesSelected?.get(this.props.id) || []
              }
              ref={this.selectClientCodeRef}
              mode="multiple"
              allowClear
              onChange={(codes) => {
                this.props.onSolutionsCodesChanges({
                  codes: codes,
                  solutionId: this.props.id,
                });
              }}
            >
              {this.state.solutionCodes?.map((solution) => {
                const currentSelectedCodes =
                  this.props.solutionsCodesSelected?.get(this.props.id) || [];
                const isDisabled =
                  currentSelectedCodes.length >= 3 &&
                  !currentSelectedCodes.includes(solution.code);
                return (
                  <Select.Option
                    key={solution.code}
                    value={solution.code}
                    disabled={isDisabled}
                  >
                    {solution.code}
                  </Select.Option>
                );
              })}
            </Box>
          )}
        </div>
      </Box>
    );
  }
}

export default injectIntl(SolutionCard);
